import { createHead } from "@vueuse/head";
import { createApp } from "vue";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import progress from "./includes/n_progress";
import "nprogress/nprogress.css";
import "./assets/css/main.css";
import print from 'vue3-print-nb'
import { createPinia } from "pinia";
import VueLazyLoad from "vue3-lazyload";
import '@fortawesome/fontawesome-free/css/all.css';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSignIn, faChevronDown,faChevronRight,faChevronLeft, faClose, faSearch, faHeart, faList, faSignOut, faUser, faCartPlus, faPhone, faTrash, faHome, faTableList, fas, faThLarge, faShoppingCart, faMinus, faPlus, faEnvelope, faPaperPlane, faCartShopping, faArrowRight,faRuler,faPallet,faMoneyBill1Wave,faCalculator,faBox,faHistory,faFrown,faUsers,faHandshake,faShirt,faHelmetSafety} from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons"; // Correct import for faInstagram
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
const pinia = createPinia();
library.add(
  faSignIn,
  faChevronDown,
  faChevronRight,
 faChevronLeft,
  faClose,
  faSearch,
  faHeart,
  faList,
  faSignOut,
  faUser,
  faCartPlus,
  faPhone,
  faTrash,
  faHome,
  faTableList,
  fas,
  faThLarge,
  faShoppingCart,
  faMinus,
  faPlus,
  faEnvelope,
  faPaperPlane,
  faInstagram,
  faArrowRight,
  faCartShopping,
  faRuler,
  faPallet,
  faMoneyBill1Wave,
  faCalculator,
  faBox,
  faHistory,
  faFrown,
  faUsers,
  faHandshake,
  faShirt,
  faHelmetSafety
);

progress(router);

const head = createHead();

createApp(App)
  .use(router)
  .use(head)
  .use(print)
  .use(pinia)
  .use(VueLazyLoad)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
